/* ══════════════════════════════════════════════════════════════════
   BUSTAH — the engine
   Scroll-scrubbed film, entrance transforms, slide-in panels,
   accordions and the contact form. Everything below this header is
   independent of the shop: it drives how the page moves, not what it
   sells. The shop runtime lives in bustah-shop.js.
   ══════════════════════════════════════════════════════════════════ */
/* ═══════════════════════════════════════════════════════════════════
   PIVOT GLOBAL — scroll-scrubbed video journey
   The background film does not autoplay. Its playhead is driven purely
   by scroll position, and anchored so each section lands on its own
   moment in the footage (field → mill → docks → sea → herd).
   ═══════════════════════════════════════════════════════════════════ */
(function(){
  var v = document.getElementById('bgv');
  if(!v) return;
  var reduce = !window.__motion;

  var pts = [], dur = 0, target = 0, cur = 0, ready = false, raf = null, primed = false;
  /* The film is 15 fps. Seeking finer than one frame just re-decodes the same
     picture, so the playhead is snapped to frame boundaries and skipped
     entirely while a previous seek is still in flight. */
  var FRAME = 1 / 15, shown = -1;

  function docH(){ return Math.max(1, document.documentElement.scrollHeight - window.innerHeight); }

  /* Build the scroll→time curve from the [data-vt] anchors on the page. */
  function build(){
    dur = (isFinite(v.duration) && v.duration > 0) ? v.duration : 10;
    var list = [];
    document.querySelectorAll('[data-vt]').forEach(function(el){
      var r  = el.getBoundingClientRect();
      var mid = r.top + window.scrollY + r.height/2 - window.innerHeight/2;
      list.push({ y: Math.max(0, Math.min(docH(), mid)), t: parseFloat(el.dataset.vt) });
    });
    list.sort(function(a,b){ return a.y - b.y; });
    pts = [{y:0, t:0}].concat(list, [{y: docH(), t: dur}]);
    /* keep it monotonic so the film never runs backwards while scrolling down */
    for(var i=1;i<pts.length;i++){
      if(pts[i].y <= pts[i-1].y) pts[i].y = pts[i-1].y + 1;
      if(pts[i].t <  pts[i-1].t) pts[i].t = pts[i-1].t;
    }
  }

  function timeAt(y){
    if(!pts.length) return 0;
    if(y <= pts[0].y) return pts[0].t;
    for(var i=1;i<pts.length;i++){
      if(y <= pts[i].y){
        var a = pts[i-1], b = pts[i];
        var k = (y - a.y) / (b.y - a.y);
        k = k*k*(3-2*k);                 /* ease inside each leg */
        return a.t + (b.t - a.t) * k;
      }
    }
    return pts[pts.length-1].t;
  }

  function tick(){
    raf = null;
    var d = target - cur;
    if(Math.abs(d) < 0.004){ cur = target; }
    else { cur += d * 0.14; raf = requestAnimationFrame(tick); }
    window.__t = cur;      /* the computed playhead, for testing */
    if(ready && !v.seeking){
      var f = Math.round(cur / FRAME) * FRAME;
      if(f !== shown){
        shown = f;
        try{ v.currentTime = Math.max(0, Math.min(dur - FRAME, f)); }catch(e){}
      }
    }
  }

  function onScroll(){
    target = timeAt(window.scrollY);
    if(reduce){ cur = target; window.__t = cur;
      if(ready && !v.seeking){ try{ v.currentTime = cur; }catch(e){} } return; }
    if(!raf) raf = requestAnimationFrame(tick);
  }

  /* iOS/Safari will not paint a frame until the element has been played once. */
  function prime(){
    if(primed) return; primed = true;
    var p = v.play();
    if(p && p.then) p.then(function(){ v.pause(); }).catch(function(){});
    else { try{ v.pause(); }catch(e){} }
  }

  function start(){
    ready = true;
    build(); onScroll();
    document.getElementById('stage').classList.add('live');
  }

  if(v.readyState >= 1) start();
  v.addEventListener('loadedmetadata', start);
  v.addEventListener('canplay', function(){ build(); onScroll(); });
  v.addEventListener('play', function(){ if(primed) v.pause(); });

  window.addEventListener('scroll', onScroll, {passive:true});
  ['touchstart','pointerdown','wheel','keydown'].forEach(function(ev){
    window.addEventListener(ev, prime, {once:true, passive:true});
  });
  setTimeout(prime, 900);

  var rt;
  window.addEventListener('resize', function(){
    clearTimeout(rt); rt = setTimeout(function(){ build(); onScroll(); }, 160);
  });
  window.addEventListener('load', function(){ build(); onScroll(); });
})();

/* ═══════════ JOURNEY RAIL ═══════════
   Built from the sections that are actually on the page rather than from
   a menu, so it is always in step with the page. A section earns a step
   by having an id and an eyebrow (.tag) — which is every section on the
   homepage except the hero, and the hero is where the rail starts from,
   not a stop on it. */
(function(){
  var rail = document.querySelector('[data-rail]');
  if(!rail || rail.children.length) return;
  var secs = [].slice.call(document.querySelectorAll('#page section[id]'));
  var html = '';
  secs.forEach(function(sec){
    var tag = sec.querySelector('.tag');
    if(!tag) return;
    var label = (tag.textContent || '').trim();
    if(!label) return;
    if(html) html += '<div class="r-line"><b></b></div>';
    html += '<a class="r-step" href="#' + sec.id + '" tabindex="-1">'
          +   '<span class="r-dot"></span><span class="r-lab">' + label + '</span>'
          + '</a>';
  });
  if(html) rail.innerHTML = html; else rail.remove();
})();

/* ═══════════ NAV ═══════════ */
(function(){
  var nav = document.querySelector('nav'), burger = document.getElementById('burger'),
      mnav = document.getElementById('mnav'), prog = document.getElementById('prog'),
      top  = document.getElementById('top'), rail = document.getElementById('rail');

  /* In a theme every one of these can legitimately be absent — a merchant
     removes a section, turns the film off, empties a menu. Before, a
     missing #rail threw inside frame() on every scroll frame, which took
     the progress bar, the back-to-top button and the active nav link down
     with it. Nothing below assumes an element exists. */
  if(burger && mnav){
    burger.addEventListener('click', function(){
      var open = mnav.classList.toggle('open');
      burger.classList.toggle('x', open);
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    mnav.querySelectorAll('a').forEach(function(a){
      a.addEventListener('click', function(){
        burger.classList.remove('x'); mnav.classList.remove('open');
        burger.setAttribute('aria-expanded', 'false');
      });
    });
  }

  var secs = [].slice.call(document.querySelectorAll('section[id]'));
  var links = [].slice.call(document.querySelectorAll('nav ul a[href^="#"]'));
  /* Offsets are cached: reading them inside the scroll handler forces the
     browser to re-lay-out the whole page on every frame. */
  var tops = [], docH = 1, vh = 1, lastId = null;
  function measure(){
    tops = secs.map(function(s){ return s.offsetTop; });
    docH = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
    vh   = window.innerHeight;
  }

  function frame(){
    var y = window.scrollY;
    if(nav)  nav.classList.toggle('stuck', y > 40);
    if(prog) prog.style.width = (y / docH * 100) + '%';
    if(top)  top.classList.toggle('on', y > 520);
    if(rail) rail.classList.toggle('on', y > vh * 0.8 && y < docH - 400);

    var cur = '';
    for(var i = 0; i < tops.length; i++) if(y >= tops[i] - 130) cur = secs[i].id;
    if(cur !== lastId){
      lastId = cur;
      links.forEach(function(a){ a.classList.toggle('act', a.getAttribute('href') === '#' + cur); });
    }
  }
  var t = false;
  window.addEventListener('scroll', function(){
    if(t) return; t = true;
    requestAnimationFrame(function(){ frame(); t = false; });
  }, {passive:true});
  var mt;
  window.addEventListener('resize', function(){
    clearTimeout(mt); mt = setTimeout(function(){ measure(); frame(); }, 150);
  });
  window.addEventListener('load', function(){ measure(); frame(); });
  measure(); frame();
  if(top) top.addEventListener('click', function(){
    window.scrollTo({top:0, behavior:'smooth'});
  });
})();

/* ═══════════ RAIL PROGRESS ═══════════ */
(function(){
  var steps = [].slice.call(document.querySelectorAll('.r-step'));
  var lines = [].slice.call(document.querySelectorAll('.r-line b'));
  if(!steps.length) return;
  var marks = steps.map(function(a){
    return document.querySelector(a.getAttribute('href'));
  }).filter(Boolean);
  if(marks.length !== steps.length) return;

  var box = [], lastActive = -2;
  function measure(){
    box = marks.map(function(m){ return [m.offsetTop, m.offsetHeight]; });
  }
  function upd(){
    var mid = window.scrollY + window.innerHeight * 0.5, active = -1;
    for(var i = 0; i < box.length; i++){
      var top = box[i][0], h = box[i][1];
      if(mid >= top) active = i;
      if(lines[i]) lines[i].style.height =
        Math.max(0, Math.min(1, (mid - top) / Math.max(1, h))) * 100 + '%';
    }
    if(active === lastActive) return;
    lastActive = active;
    steps.forEach(function(s, i){
      s.classList.toggle('now', i === active);
      s.classList.toggle('done', i < active);
    });
  }
  var t = false;
  window.addEventListener('scroll', function(){
    if(t) return; t = true;
    requestAnimationFrame(function(){ upd(); t = false; });
  }, {passive:true});
  var rt2;
  window.addEventListener('resize', function(){
    clearTimeout(rt2); rt2 = setTimeout(function(){ measure(); upd(); }, 150);
  });
  window.addEventListener('load', function(){ measure(); upd(); });
  measure(); upd();
})();

/* ═══════════ SCROLL-LINKED FOREGROUND ═══════════
   The aim is not to animate the content — it is to stop it reading as a
   layer on top of the film and make it part of the picture.

   So nothing slides. A block dissolves up where it already is, the way a
   title appears in a shot, and every section is given the same slow push
   the camera gives the footage. With the grain and the vignette falling
   across the type as well (see #lens in the stylesheet), the two read as
   one image rather than as text over video.

   All of it is a function of scroll position, never of a timer, so it runs
   backwards when you scroll back, in step with the footage.

   Geometry is measured once and cached — never inside the scroll handler,
   which would force a full re-layout on every frame — and an element is
   only written to when its progress has actually moved. */
(function(){
  var root = document.documentElement;
  if(!/(^| )js( |$)/.test(root.className)) root.className += ' js';
  if(!window.__motion) return;

  var items = [], drifts = [], vh = 1, lastW = 0, queued = false;

  /* A block dissolves up as it crosses the lower part of the screen —
     starting as its top passes the bottom edge (LEAD) and fully there a
     little under half a screen later (SPAN). STEP staggers the items of a
     row, in scroll distance, not time. */
  var LEAD = 1.10, SPAN = 0.42, STEP = 0.05;

  /* WHICH WAY CONTENT ARRIVES
     Scrolling already carries everything up the screen, so a block that
     also rises as it enters is arriving on the one axis the page is
     already using — it reads as sliding up, whatever the timing. These
     bring it in on a different axis instead. Add ?enter=<name> to the URL
     to try another; 'depth' is the default.

       depth     it comes toward you out of the picture, growing into
                 place — the same axis the camera dollies along
       sides     it converges inward: blocks left of centre come from the
                 left, blocks right of centre from the right
       down      it settles downward from above, against the scroll
       dissolve  no movement at all, just a fade
  */
  var ENTER = (/[?&]enter=(depth|sides|down|dissolve)/.exec(location.search) || [,'depth'])[1];
  var DEPTH = 0.14, SIDE = 90, DOWN = 70;
  /* PUSH is the camera move: a section grows by this much while it crosses
     the screen, matching the way the footage dollies forward. It replaces
     the vertical drift, which was the very thing that made the content look
     like it was sliding over the film rather than sitting inside it.
     PHOTO is the same idea for a photograph inside its frame. */
  var PUSH = 0.045, PHOTO = 18;

  function ease(t){ return t <= 0 ? 0 : t >= 1 ? 1 : t * t * (3 - 2 * t); }

  function collect(){
    items = []; drifts = [];
    /* .rvl and .rvr used to mean "slide in from the left / right". Nothing
       slides any more, so all three are the same dissolve; the classes stay
       in the markup because they still say which side a block sits on. */
    document.querySelectorAll('#page .rv,#page .rvl,#page .rvr').forEach(function(el){
      items.push({ el: el, i: 0, p: -1 });
    });
    document.querySelectorAll('#page .stg').forEach(function(g){
      for(var i = 0; i < g.children.length; i++)
        items.push({ el: g.children[i], dx: 0, i: i, n: i, p: -1 });
    });
    document.querySelectorAll('#page .nbar').forEach(function(bar){
      items.push({ el: bar, bar: +bar.getAttribute('data-w'), i: 0, p: -1 });
    });
    /* Not '#page > section' — Shopify wraps every section in its own
       <div id="shopify-section-…">, so the direct-child selector this was
       written with matches nothing in a theme and the camera push silently
       never applies. A descendant selector survives the wrapper. */
    document.querySelectorAll('#page section > .wrap, footer > .ftop').forEach(function(el){
      el.classList.add('drift');
      drifts.push({ el: el, p: -1 });
    });
    document.querySelectorAll('#page .bimg img').forEach(function(im){
      im.classList.add('para');
      drifts.push({ el: im, p: -1, pc: 1 });
    });
  }

  function measure(){
    vh = window.innerHeight; lastW = window.innerWidth;
    var i, r;

    /* Every position below is read with the animation cleared. Measuring
       while a section's push is still applied reports its contents away
       from where they really sit, by a different amount for each one.
       update() runs straight after and repaints. */
    for(i = 0; i < items.length; i++) items[i].p = -1;
    for(i = 0; i < drifts.length; i++){ drifts[i].el.style.transform = ''; drifts[i].p = -1; }

    var mid = window.innerWidth / 2;
    for(i = 0; i < items.length; i++){
      var r0 = items[i].el.getBoundingClientRect();
      items[i].top = r0.top + window.pageYOffset;
      /* which side of the screen it sits on, for the 'sides' entrance */
      items[i].side = items[i].el.classList.contains('rvl') ? -1
                    : items[i].el.classList.contains('rvr') ?  1
                    : (r0.left + r0.width / 2) < mid ? -1 : 1;
    }
    /* A row that has wrapped into a column no longer needs an index
       stagger: its items already arrive one after another because they are
       at different heights. Staggering those as well makes the lower ones
       turn up far too late. */
    for(i = 0; i < items.length; i++){
      var it = items[i];
      if(it.n === undefined) continue;
      var prev = i > 0 ? items[i - 1] : null;
      it.i = (it.n > 0 && prev && Math.abs(prev.top - it.top) > 8) ? 0 : it.n;
    }
    for(i = 0; i < drifts.length; i++){
      r = drifts[i].el.getBoundingClientRect();
      drifts[i].top = r.top + window.pageYOffset;
      drifts[i].h = r.height;
      if(drifts[i].pc) drifts[i].el.style.transform = 'scale(1.26)';
    }
  }

  function update(){
    queued = false;
    var y = window.pageYOffset, i, it, p;

    for(i = 0; i < items.length; i++){
      it = items[i];
      var start = it.top - vh * LEAD + (it.i > 5 ? 5 : it.i) * vh * STEP;
      p = ease((y - start) / (vh * SPAN));
      p = Math.round(p * 100) / 100;         /* 100 steps is past the eye's reach */
      if(p === it.p) continue;
      it.p = p;
      if(it.bar){
        it.el.style.width = (it.bar * p).toFixed(1) + '%';
      } else {
        /* Promote only while it is actually moving. On its own layer the
           browser composites the change; without one it repaints the text,
           and text with a shadow is the most expensive thing here to
           repaint. */
        /* Promote only while it is actually dissolving. On its own layer
           the browser composites the change; without one it repaints the
           text, and text with a shadow is the most expensive thing here to
           repaint. */
        var moving = p > 0 && p < 1;
        if(moving !== it.m){ it.m = moving; it.el.style.willChange = moving ? 'transform,opacity' : ''; }
        var q = 1 - p;
        it.el.style.opacity = p;
        it.el.style.transform =
            ENTER === 'sides' ? 'translate3d(' + (q * SIDE * it.side).toFixed(1) + 'px,0,0)'
          : ENTER === 'down'  ? 'translate3d(0,' + (-q * DOWN).toFixed(1) + 'px,0)'
          : ENTER === 'dissolve' ? 'none'
          :                     'scale(' + (1 - q * DEPTH).toFixed(4) + ')';
      }
    }

    for(i = 0; i < drifts.length; i++){
      it = drifts[i];
      /* 0 as the block's top reaches the bottom of the screen, 1 as its
         bottom leaves the top — a continuous ride across the viewport */
      p = (y + vh - it.top) / (it.h + vh);
      p = p < 0 ? 0 : p > 1 ? 1 : p;
      p = Math.round(p * 200) / 200;
      if(p === it.p) continue;
      it.p = p;
      it.el.style.transform = it.pc
        /* the photograph pans inside its own frame */
        ? 'translate3d(0,' + ((p - 0.5) * PHOTO).toFixed(2) + '%,0) scale(1.26)'
        /* the section is pushed by the same camera that moves the footage */
        : 'scale(' + (1 + p * PUSH).toFixed(4) + ')';
    }
  }

  function onScroll(){ if(queued) return; queued = true; requestAnimationFrame(update); }
  function refresh(){ measure(); update(); }

  collect(); refresh();
  window.addEventListener('scroll', onScroll, {passive:true});

  var rt;
  function debounced(){ clearTimeout(rt); rt = setTimeout(refresh, 150); }
  window.addEventListener('resize', function(){
    /* a phone's address bar and its keyboard both change the height alone;
       re-laying the page out under the visitor for that is worse than not */
    if(window.innerWidth === lastW) return;
    debounced();
  });
  window.addEventListener('orientationchange', function(){ setTimeout(refresh, 260); });
  window.addEventListener('load', refresh);
  if(document.fonts && document.fonts.ready) document.fonts.ready.then(refresh);
  document.querySelectorAll('#page img').forEach(function(im){
    if(!im.complete) im.addEventListener('load', debounced, {once:true});
  });
  /* opening an accordion row moves everything below it */
  window.__remeasure = refresh;

  /* Rescan, for content that arrives after load.

     collect() snapshots the elements to animate once. Anything injected
     later — a category tab swapping the product grid, Show more adding a
     page — is not in that list, so nothing ever raises it from the
     opacity: 0 the stylesheet starts it at. The cards are in the DOM,
     correct in every way, and invisible. The grid looks empty.

     __remeasure is not enough: it re-measures the elements already
     known. Anything that changes WHICH elements exist has to call this. */
  window.__rescan = function(){ collect(); refresh(); };
})();

/* ═══════════ PANELS ═══════════
   The page shows headings only; every piece of detail lives in a panel that
   slides in from the right. One is open at a time. */
(function(){
  var scrim = document.getElementById('scrim');
  if(!scrim) return;
  var open = null, lastFocus = null;

  /* Every panel is moved to be a direct child of <body> before anything
     else happens.

     #page is position:relative with z-index:2, which makes it a stacking
     context — so a panel rendered inside it can never rise above the nav
     (z-index 1000) or the floating pair (900), however high its own
     z-index is. In the original this was free, because the panels were
     written straight into the body. In a theme they arrive inside
     whichever section declared them, which is inside #page.

     Relocating them also makes `position: fixed` safe for good: a panel
     is no longer at the mercy of an ancestor picking up a transform. */
  function hoistPanels(root){
    [].slice.call((root || document).querySelectorAll('.panel')).forEach(function(pan){
      if(pan.parentElement === document.body) return;
      /* The theme editor re-renders a section in place when it is edited,
         which brings a fresh copy of that section's panel back inside
         #page — with the same id as the one already hoisted. Drop the old
         one first, or getElementById starts returning the buried copy. */
      var twin = document.getElementById(pan.id);
      if(twin && twin !== pan && twin.parentElement === document.body) twin.remove();
      document.body.appendChild(pan);
    });
  }
  hoistPanels();
  document.addEventListener('shopify:section:load', function(e){ hoistPanels(e.target); });

  function close(){
    if(!open) return;
    var was = open;
    was.classList.remove('open');
    was.setAttribute('aria-hidden', 'true');
    setTimeout(function(){ if(!was.classList.contains('open')) was.classList.remove('live'); }, 520);
    open = null;
    scrim.classList.remove('on');
    setTimeout(function(){ if(!open) scrim.hidden = true; }, 420);
    document.body.style.overflow = '';
    if(lastFocus && lastFocus.focus) lastFocus.focus();
    /* Announced rather than assumed. The shop runtime rewrites the URL
       when a product popup opens; it needs to know about every close —
       the X, the scrim and Escape alike — and listening for each of those
       separately is how one of them ends up forgotten. */
    document.dispatchEvent(new CustomEvent('bustah:panelclose', { detail: was }));
  }

  function show(id, trigger){
    var p = document.getElementById(id);
    if(!p) return;
    if(open && open !== p){ open.classList.remove('open'); open.classList.remove('live'); }
    lastFocus = trigger || null;
    scrim.hidden = false;
    p.classList.add('live');
    /* one frame, so the scrim and the panel have a state to transition from */
    requestAnimationFrame(function(){
      scrim.classList.add('on');
      p.classList.add('open');
    });
    p.removeAttribute('aria-hidden');
    open = p;
    document.body.style.overflow = 'hidden';
    var x = p.querySelector('.p-x');
    if(x) setTimeout(function(){ x.focus(); }, 120);
  }

  document.addEventListener('click', function(e){
    var t = e.target.closest('[data-panel]');
    if(t){
      /* Every panel trigger in this theme is a real <a href> to a real
         page — that is what makes the catalogue crawlable. So a modified
         click has to be left alone: cmd- or ctrl-clicking a collection
         row should open that collection in a new tab, exactly as the
         markup promises. Only a plain left click becomes a panel. */
      if(t.tagName === 'A' && (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0)) return;
      /* If the named panel is not in the document — a section switched
         off in the editor, a block pointing at something that no longer
         exists — do not swallow the click. An <a> still has a real page
         behind it, and a trigger that silently does nothing is the worst
         of the three outcomes. */
      var pid = t.getAttribute('data-panel');
      if(!document.getElementById(pid)){
        var hrf = t.getAttribute('href');
        if(t.tagName === 'A' && hrf && hrf !== '#') return;
        e.preventDefault();
        return;
      }
      e.preventDefault();
      show(pid, t);
      return;
    }
    if(e.target.closest('[data-close]') || e.target === scrim) close();
  });
  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape' && open) close();
  });
  /* keep tabbing inside the open panel */
  document.addEventListener('focusin', function(e){
    if(open && !open.contains(e.target) && !scrim.contains(e.target)){
      var f = open.querySelector('.p-x');
      if(f) f.focus();
    }
  });
  window.__closePanel = close;
  window.__openPanel = function(id){ show(id, null); };
})();

/* ═══════════ DEAD IN-PAGE LINKS ═══════════
   The menu is edited in Shopify, the sections are edited in the theme
   editor, and neither knows about the other. Switch a section off — or
   merge two, as Made and About were merged — and any menu item pointing
   at its anchor becomes a link that scrolls nowhere, which reads as a
   broken site rather than a changed one.

   So on the homepage only, a nav link to an anchor that is not on the
   page is removed. Links to real pages are never touched. */
(function () {
  if (!document.body.classList.contains('tpl-index')) return;
  /* The footer carries the same menus, so it inherits the same dead
     anchors — and the footer is this site's main internal-linking
     surface, which is the worst place to leave links that go nowhere. */
  var links = document.querySelectorAll('nav a[href^="#"], #mnav a[href^="#"], footer a[href^="#"]');
  Array.prototype.forEach.call(links, function (a) {
    var id = a.getAttribute('href').slice(1);
    if (!id || document.getElementById(id)) return;
    var li = a.closest('li');
    (li || a).remove();
  });
})();

/* ═══════════ ACCORDION ═══════════ */
function toggleAcc(h){
  var item = h.parentElement, open = item.classList.contains('open');
  /* Close only the siblings in THIS accordion. A dropdown in front of the
     film and an accordion inside a panel are two different lists, and
     opening one should not silently collapse the other. */
  var box = item.parentElement || document;
  box.querySelectorAll('.acc-i.open').forEach(function(i){
    i.classList.remove('open');
    i.querySelector('.acc-b').style.maxHeight = '';
    var hd = i.querySelector('.acc-h'); if(hd) hd.setAttribute('aria-expanded','false');
  });
  if(!open){
    item.classList.add('open');
    h.setAttribute('aria-expanded','true');
    /* Measure rather than guess. A fixed max-height in the stylesheet is a
       number someone has to keep in step with the content, and the day it
       falls behind the row is silently cut off — which is exactly what
       twelve products did at phone width. */
    setAccHeight(item);
  }
  /* the row's height animates, so re-measure the page as it settles */
  if(window.__remeasure){
    var n = 0, t = setInterval(function(){
      window.__remeasure();
      if(++n > 10) clearInterval(t);
    }, 60);
  }
}

function setAccHeight(item){
  var body = item.querySelector('.acc-b'), inner = body.firstElementChild;
  body.style.maxHeight = ((inner ? inner.offsetHeight : body.scrollHeight) + 4) + 'px';
}

/* A wrapped row is a different height at a different width, so an open
   accordion is re-measured whenever the page is. */
addEventListener('resize', function(){
  document.querySelectorAll('.acc-i.open').forEach(setAccHeight);
});


/* ═══════════ BLOG MODALS ═══════════ */
function openModal(id){
  document.getElementById(id).classList.add('open');
  document.body.style.overflow = 'hidden';
}
function closeModal(id){
  document.getElementById(id).classList.remove('open');
  document.body.style.overflow = '';
}
function bgClose(e, id){ if(e.target === document.getElementById(id)) closeModal(id); }
document.addEventListener('keydown', function(e){
  if(e.key !== 'Escape') return;
  document.querySelectorAll('.mov.open').forEach(function(m){ m.classList.remove('open'); });
  document.body.style.overflow = '';
});

/* ═══════════════════════════════════════════════════════════════
   CONTACT FORM — posts to the Shopify contact endpoint at
   bustah.co/contact, exactly as the store's own contact page does
   (form_type=contact, contact[name], contact[email], contact[body]).

   It submits natively rather than in the background. A background
   fetch would be a cross-origin POST to a different domain and the
   browser would hide the response from us, so we could not tell a
   delivered message from a rejected one — the visitor would be shown
   a thank-you that might be a lie. A native submit hands them
   Shopify's own confirmation instead, which is the truthful one.

   Works with JavaScript off: the browser submits the same form the
   same way. All this module adds is catching the three mistakes
   people actually make before the page navigates.
   ═══════════════════════════════════════════════════════════════ */
(function(){
  var form = document.querySelector('.p-form');
  if(!form) return;

  var err = document.createElement('p');
  err.className = 'ferr';
  err.hidden = true;
  err.setAttribute('role', 'alert');
  form.insertBefore(err, form.querySelector('button[type="submit"]'));

  function fail(e, msg, field){
    e.preventDefault();
    err.textContent = msg; err.hidden = false;
    form.querySelectorAll('.fg.bad').forEach(function(g){ g.classList.remove('bad'); });
    if(field){
      var g = field.closest('.fg');
      if(g) g.classList.add('bad');
      field.focus();
    }
    return false;
  }

  form.addEventListener('submit', function(e){
    err.hidden = true;
    var name  = form.elements['contact[name]'],
        email = form.elements['contact[email]'],
        body  = form.elements['contact[body]'];

    if(!name.value.trim())
      return fail(e, 'Please tell us your name.', name);
    if(!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email.value.trim()))
      return fail(e, 'That email address does not look right.', email);
    if(body.value.trim().length < 10)
      return fail(e, 'Please add a little detail about what you are after.', body);

    var btn = form.querySelector('button[type="submit"]');
    if(btn){ btn.disabled = true; btn.textContent = 'Sending…'; }
  });
})();